import classNames from 'classnames'
import React from 'react'

import { GridColumn } from '../../grid/grid-column.js'
import { Grid } from '../../grid/grid.js'
import { RadioCard, RadioCardProps } from '../radio-card/radio-card.js'

export type RadioCardGroupValue = string | null

export interface RadioCardGroupProps {
    id: string
    name: string
    options: RadioCardProps[]
    value?: RadioCardGroupValue
    onChange?: (value: RadioCardGroupValue) => void
    className?: string
}

export const RadioCardGroup = (props: RadioCardGroupProps): JSX.Element => {
    const className: string = classNames('radio-group', props.className)

    const handleChange = (val: string, checked: boolean, onChange?: (checked: boolean) => void): void => {
        if (props.onChange) {
            props.onChange(val)
        }

        if (onChange) {
            onChange(checked)
        }
    }

    const isChecked = (val: string): boolean => {
        const currentValue = props.value

        return val === currentValue
    }

    const getOptionInput = (option: RadioCardProps): React.InputHTMLAttributes<HTMLInputElement> => {
        return {
            ...option.input,
            name: props.name,
        }
    }

    return (
        <fieldset className={className} id={props.id}>
            <Grid gutter="mobile">
                {props.options.map((option: RadioCardProps, index: number) => {
                    const val = option.value || 'on'
                    const onChange = (checked: boolean) => handleChange(val, checked, option.onChange)

                    return (
                        <GridColumn key={index}>
                            <RadioCard
                                {...option}
                                onChange={onChange}
                                checked={isChecked(val)}
                                input={getOptionInput(option)}
                                hiddenIndicator={props.options.length === 1}
                            />
                        </GridColumn>
                    )
                })}
            </Grid>
        </fieldset>
    )
}
